'use client';

import useAuth from '@/context/auth/useAuth';
import { useEffect, useState } from 'react';
import dict from '@/dictionaries/fa.json';
import { Button } from '@/components/ui/Button';
import { useRouter } from 'next/navigation';
import { Drawer, DrawerContent } from '@/components/ui/Drawer';
import { CloseSvg } from '@/assets/Icons';
import { DialogTitle } from '@/components/ui/Dialog';

function InAppLogin() {
    const router = useRouter();
    const [open, setOpen] = useState(false);
    const { inAppLoginModalIsOpen, setInAppLoginModalIsOpen, previousUrl, toGoUrl } = useAuth();

    useEffect(() => {
        setOpen(inAppLoginModalIsOpen);
    }, [inAppLoginModalIsOpen]);
    useEffect(() => {
        setInAppLoginModalIsOpen({
            isOpen: open,
            previousUrl,
            toGoUrl,
            noReset: true
        });
    }, [open]);

    function goToLoginPage() {
        setOpen(false);
        setTimeout(() => {
            router.push('/login');
        }, 100);
    }

    return (
        <Drawer open={open} onOpenChange={setOpen}>
            <DrawerContent className="max-w-[450px] px-6" aria-describedby="">
                <DialogTitle className="hidden" />
                <Button
                    onClick={() => setOpen(false)}
                    variant="ghost"
                    size="icon"
                    className="vertical-panel-close-btn">
                    <CloseSvg className="vertical-panel-close-btn-icon" />
                </Button>
                <div className="in-app-login-container">
                    <h2 className="in-app-login-title">{dict.shouldEnterTheApp}</h2>
                    <p className="in-app-login-description">{dict.getInAndLogin}</p>
                    <div className="in-app-login-buttons-container">
                        <Button onClick={goToLoginPage} className="in-app-login-button primary">
                            {dict.enter}
                        </Button>
                        <Button
                            onClick={() => setOpen(false)}
                            className="in-app-login-button secondary">
                            {dict.cancel}
                        </Button>
                    </div>
                </div>
            </DrawerContent>
        </Drawer>
    );
}

export default InAppLogin;
